import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { ADD_TICKET, ADD_TICKET_FAILED, ADD_TICKET_SUCCESS, TICKET, TICKET_FAILED, TICKET_SUCCESS, UPDATE_TICKET, UPDATE_TICKET_FAILED, UPDATE_TICKET_SUCCESS } from "./actionTypes"
import { getAuthHeader } from "../../Lib/utils"


export const getTickets = () => async (dispatch) => {
  dispatch({
    type: TICKET,
  });
  try {
    let response = await api(`ticket/ticketList`, "get", {}, getAuthHeader());
    dispatch({
      type: TICKET_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Ticket list error ====>", error);
    return dispatch({
      type: TICKET_FAILED,
      payload: error?.message,
    });
  }
};

export const addTicket = (data) => async dispatch => {
  dispatch({
    type: ADD_TICKET
  })
  try {
    let response = await api(`ticket/add`, 'post', data, getAuthHeader())
    console.log('add ticket data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_TICKET_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while Adding ticket error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_TICKET_FAILED,
      payload: error?.message
    })
  }
}

export const updateTicket = (id, data) => async dispatch => {
  dispatch({
    type: UPDATE_TICKET
  })
  try {
    let response = await api(`ticket/update/${id}`, 'put', data, getAuthHeader())
    console.log('update ticket data', response);
    toast.success("Updated Successfully");
    dispatch({
      type: UPDATE_TICKET_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while updating ticket error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_TICKET_FAILED,
      payload: error?.message
    })
  }
}